export default {
      id: "color_attention-usage",
      viewBox: "0 0 30 30",
      url: __webpack_public_path__ + "sprite.svg#color_attention",
      toString: function () {
        return this.url;
      }
    }